import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileFireManagerComponent } from './file-fire-manager/file-fire-manager.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonModule } from '@angular/material/button';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { DateViewHtmlComponent } from './date_view/date_view.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatIconModule,
        MatProgressBarModule,
        MatButtonModule,
        AngularFontAwesomeModule,
        MatNativeDateModule,
        MatDatepickerModule,
     ],
    declarations: [
        FileFireManagerComponent,
        DateViewHtmlComponent
    ],
    exports: [
        FileFireManagerComponent,
        DateViewHtmlComponent
    ]
})
export class SharedModule {}